<p-table #dt [value]="orders" styleClass="p-datatable" [rowHover]="true" [rows]="5" [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[5, 10, 25]" responsiveLayout="scroll" [paginator]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders" [filterDelay]="0">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="medName">
        <div class="flex justify-content-between align-items-center">
          Medication
          <p-sortIcon field="medName"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="dosage">
        <div class="flex justify-content-between align-items-center">
          Dosage
          <p-sortIcon field="dosage"></p-sortIcon>
        </div>
      </th>

      <th pSortableColumn="route">
        <div class="flex justify-content-between align-items-center">
          Route
          <p-sortIcon field="route"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="administeredString">
        <div class="flex justify-content-between align-items-center">
          Administered
          <p-sortIcon field="administeredString"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="prnLastGivenTimeString">
        <div class="flex justify-content-between align-items-center">
          Last Given Time
          <p-sortIcon field="prnLastGivenTimeString"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="prnDosingInstructions">
        <div class="flex justify-content-between align-items-center">
          Dosing Instructions
          <p-sortIcon field="prnDosingInstructions"></p-sortIcon>
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          <div class="actions-title-container">Actions</div>
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-order>
    <tr class="p-selectable-row">
      <td>
        {{ order.medName }}
      </td>
      <td>
        {{ order.dosage }}
      </td>
      <td>
        {{ order.route }}
      </td>
      <td>
        {{ order.administeredString }}
      </td>
      <td>
        {{ order.prnLastGivenTimeString }}
      </td>
      <td>
        {{ order.prnDosingInstructions }}
      </td>
      <td class="actions-container">
        <button pButton type="button" class="p-button-info" icon="pi pi-eye" pTooltip="Ready to Administer Order"
          (click)="openAdministerMedDialog(order)"></button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8">No PRN orders found.</td>
    </tr>
  </ng-template>
</p-table>